import { render, staticRenderFns } from "./sectionSmallHomeTwo.vue?vue&type=template&id=1a884868&"
var script = {}


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "sectionSmallHomeTwo.vue"
export default component.exports